/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions*/

import React, { useState, useEffect, useRef, useContext } from 'react';
import { LoaderContext } from '@fitinsur/contexts';
import { useResetOperationState } from 'services/OperationService';
import { useGetOperationNavigation } from 'services/OperationService';
import Icon from 'components/Icon';
import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    ContentTextarea,
    DialogCancel,
    DialogConfirm,
} from './styles';

export default function ModalEditConfirmation({ idOperation, show, setDialog, history }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const [visible, setVisible] = useState(show);

    const myRef = useRef();

    useEffect(() => {
        setVisible(show);
    }, [show]);

    const {
        data: useResetOperationStateData,
        loading: useResetOperationStateLoading,
        error: useResetOperationStateError,
        status: useResetOperationStateStatus,
        request: useResetOperationStateRequest,
    } = useResetOperationState(idOperation);

    const {
        data: useGetOperationNavigationData,
        loading: useGetOperationNavigationLoading,
        error: useGetOperationNavigationError,
        status: useGetOperationNavigationStatus,
        request: useGetOperationNavigationRequest,
    } = useGetOperationNavigation(idOperation);

    useEffect(() => {
        updateIsLoadingStatus(
            useGetOperationNavigationLoading ||
            useResetOperationStateLoading
        )
    }, [
        useGetOperationNavigationLoading,
        useResetOperationStateLoading
    ]);

    useEffect(() => {
        if (useGetOperationNavigationStatus === 200) {
            if (useGetOperationNavigationData.value?.route) {
                history.push(useGetOperationNavigationData.value?.route)
                window.location.reload();
                return
            };
        }
    }, [useGetOperationNavigationStatus]);

    useEffect(() => {
        if (useResetOperationStateStatus === 200) {
            return history.push(`/send-quote-client-contacts/${idOperation}`);
        }
    }, [useResetOperationStateStatus]);

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon>
                    <Icon name='exclamation' />
                    <DialogText>Important notice</DialogText>
                </DialogIcon>
                <ContentTextarea>
                    <p>
                        You have made a change to the application details which were used to generate the NBI request and/or NBI.
                        Such change may materially affect underwriters’ assessment of the risk and/or the terms and conditions offered as part of the NBI.
                    </p>
                    <p>
                        In the absence of a revised NBI, please only proceed where the confirmations noting the change, by relevant underwriters, are saved on file.
                    </p>
                    <p>
                        {"If you click RE-SEND APPLICATION, you will re-send the application form to the Client and then UWs, otherwise click SAVE & RETURN to accept the changes and return to the previous stage."}
                    </p>
                    <br />
                    <DialogCancel onClick={() => useGetOperationNavigationRequest()}>{'SAVE & RETURN'}</DialogCancel>
                    <DialogConfirm onClick={() => useResetOperationStateRequest({ idDomainOrigin: 26 })}>RE-SEND APPLICATION</DialogConfirm>
                </ContentTextarea>
            </DialogBody>
        </Dialog>
    );
}